import { notifications as notificationsService } from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../../../error/state';
import logger from '../../../../../../common/services/logService';
import Types from '../types';

export const updateNotificationStart = () => ({
  type: Types.UPDATE_NOTIFICATION_START,
});

export const updateNotificationEnd = () => ({
  type: Types.UPDATE_NOTIFICATION_END,
});

export default ({ notification, callback }) =>
  async dispatch => {
    try {
      dispatch(updateNotificationStart());
      await notificationsService.updateNotification(notification);
      if (callback) callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(updateNotificationEnd());
    }
  };
